/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import YouTubeVideo from './YouTubeVideo'
import * as lib from '../lib/lib'

export default class SolutionsHero {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    this.href = jQuery('.buttons a', this.$element)
    this.wizard = jQuery('#app-solutions-wizard')
    this._scrollToWizard()

    document.addEventListener('on-youtube-iframe-api-ready', () => {
      console.log('addEvent - SolutionsHero')
      new YouTubeVideo(jQuery('.b-video', this.$element)[0])
    })

    jQuery('.s-solutions-hero__toggle-video', this.$element).on('click', () => {
      console.log(0)
      //   jQuery('.b-video', this.$element).youtubeVideo('play')
      new YouTubeVideo(jQuery('.b-video', this.$element)[0]).play()
    })
    jQuery('.s-solutions-hero__video-playBtn', this.$element).on(
      'click',
      () => {
        console.log(1)
        jQuery(this).hide()
        // jQuery('.b-video', this.$element).youtubeVideo('playVideo')
        new YouTubeVideo(jQuery('.b-video', this.$element)[0]).playVideo()
      }
    )

    jQuery(document).on('video-playing', () => {
      jQuery('.s-solutions-hero__video-playBtn', this.$element).hide()
    })

    jQuery(document).on('video-ended', () => {
      jQuery('.s-solutions-hero__video-playBtn', this.$element).show()
    })
  }

  _scrollToWizard() {
    this.href.click((e) => {
      e.preventDefault()
      lib.scrollToElem(this.wizard, 50)
    })
  }
}
